export default "__VITE_ASSET__SPRjEc5TCHUfgNsYUjJJwQ__"